import { render, staticRenderFns } from "./AltLayout.vue?vue&type=template&id=cbbaf206&scoped=true&"
import script from "./AltLayout.vue?vue&type=script&lang=js&"
export * from "./AltLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbbaf206",
  null
  
)

export default component.exports